export const MESSAGE_ROLES = {
  ASSISTANT: 'assistant',
  USER: 'user'
}

export const BLOCK_TYPES = {
  TEXT: 'text',
  RESULTS: 'search_results',
  END: 'end_chat',
  AD_CARD: 'ad_card',
  CONTACT_OPTIONS: 'contact_options'
}
